export const readNotification = (notificationId: string) => {
	return {
		url: `notification-service/notification/${notificationId}/status/R`,
		method: 'PATCH',
	};
};
